/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  GetPersonalHealthRecordCsvResponse,
  GetPersonalHealthRecordCsvResponseFromJSON,
  GetPersonalHealthRecordCsvResponseToJSON,
  GetPersonalHealthRecordZipExportResponse,
  GetPersonalHealthRecordZipExportResponseFromJSON,
  GetPersonalHealthRecordZipExportResponseToJSON,
  PhrAuthToken,
  PhrAuthTokenFromJSON,
  PhrAuthTokenToJSON,
  PhrCustomBadRequest1,
  PhrCustomBadRequest1FromJSON,
  PhrCustomBadRequest1ToJSON,
  PhrCustomBadRequest2,
  PhrCustomBadRequest2FromJSON,
  PhrCustomBadRequest2ToJSON,
  PhrPersonalHealthRecord,
  PhrPersonalHealthRecordFromJSON,
  PhrPersonalHealthRecordToJSON,
  PhrShareSetting,
  PhrShareSettingFromJSON,
  PhrShareSettingToJSON,
  PostAuthTokenRequestBody,
  PostAuthTokenRequestBodyFromJSON,
  PostAuthTokenRequestBodyToJSON,
  PostPersonalHealthRecordCsvGenerateResponse,
  PostPersonalHealthRecordCsvGenerateResponseFromJSON,
  PostPersonalHealthRecordCsvGenerateResponseToJSON,
  PostPersonalHealthRecordFileImportsRequestBody,
  PostPersonalHealthRecordFileImportsRequestBodyFromJSON,
  PostPersonalHealthRecordFileImportsRequestBodyToJSON,
  PostPersonalHealthRecordZipExportGenerateResponse,
  PostPersonalHealthRecordZipExportGenerateResponseFromJSON,
  PostPersonalHealthRecordZipExportGenerateResponseToJSON,
  PutShareSettingRequestBody,
  PutShareSettingRequestBodyFromJSON,
  PutShareSettingRequestBodyToJSON,
} from "../models";

export interface DeletePatientPersonalHealthRecordRequest {
  types: Array<DeletePatientPersonalHealthRecordTypesEnum>;
  familyAccountId?: number;
}

export interface GetPatientPersonalHealthRecordRequest {
  types: Array<GetPatientPersonalHealthRecordTypesEnum>;
  familyAccountId?: number;
}

export interface GetPatientPersonalHealthRecordByTheOthersRequest {
  patientId: number;
  authToken: string;
  types: Array<GetPatientPersonalHealthRecordByTheOthersTypesEnum>;
  familyAccountId?: number;
}

export interface GetPatientPersonalHealthRecordCSVRequest {
  familyAccountId?: number;
}

export interface GetPatientPersonalHealthRecordCsvRequest {
  familyAccountId?: number;
}

export interface GetPatientPersonalHealthRecordZIPRequest {
  types: Array<GetPatientPersonalHealthRecordZIPTypesEnum>;
  familyAccountId?: number;
}

export interface GetPatientPersonalHealthRecordZipExportRequest {
  familyAccountId?: number;
}

export interface GetPatientShareSettingRequest {
  familyAccountId?: number;
}

export interface PostAuthTokenRequest {
  patientId: number;
  postAuthTokenRequestBody: PostAuthTokenRequestBody;
  familyAccountId?: number;
}

export interface PostPatientPersonalHealthRecordCsvGenerateRequest {
  familyAccountId?: number;
}

export interface PostPatientPersonalHealthRecordFileImportsRequest {
  type: PostPatientPersonalHealthRecordFileImportsTypeEnum;
  postPersonalHealthRecordFileImportsRequestBody: PostPersonalHealthRecordFileImportsRequestBody;
  familyAccountId?: number;
}

export interface PostPatientPersonalHealthRecordZipExportGenerateRequest {
  types: Array<PostPatientPersonalHealthRecordZipExportGenerateTypesEnum>;
  familyAccountId?: number;
}

export interface PutPatientShareSettingRequest {
  putShareSettingRequestBody: PutShareSettingRequestBody;
  familyAccountId?: number;
}

/**
 *
 */
export class PersonalHealthRecordApi extends runtime.BaseAPI {
  /**
   * Delete the patient\'s own personal health record using JWT
   */
  async deletePatientPersonalHealthRecordRaw(
    requestParameters: DeletePatientPersonalHealthRecordRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.types === null || requestParameters.types === undefined) {
      throw new runtime.RequiredError(
        "types",
        "Required parameter requestParameters.types was null or undefined when calling deletePatientPersonalHealthRecord."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    if (requestParameters.types) {
      queryParameters["types"] = requestParameters.types;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patient/personal-health-record`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete the patient\'s own personal health record using JWT
   */
  async deletePatientPersonalHealthRecord(
    requestParameters: DeletePatientPersonalHealthRecordRequest,
    initOverrides?: RequestInit
  ): Promise<void> {
    await this.deletePatientPersonalHealthRecordRaw(requestParameters, initOverrides);
  }

  /**
   * Get the patient\'s own personal health record using JWT
   */
  async getPatientPersonalHealthRecordRaw(
    requestParameters: GetPatientPersonalHealthRecordRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PhrPersonalHealthRecord>> {
    if (requestParameters.types === null || requestParameters.types === undefined) {
      throw new runtime.RequiredError(
        "types",
        "Required parameter requestParameters.types was null or undefined when calling getPatientPersonalHealthRecord."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    if (requestParameters.types) {
      queryParameters["types"] = requestParameters.types;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patient/personal-health-record`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PhrPersonalHealthRecordFromJSON(jsonValue));
  }

  /**
   * Get the patient\'s own personal health record using JWT
   */
  async getPatientPersonalHealthRecord(
    requestParameters: GetPatientPersonalHealthRecordRequest,
    initOverrides?: RequestInit
  ): Promise<PhrPersonalHealthRecord> {
    return promiseRetry(
      (retry) =>
        this.getPatientPersonalHealthRecordRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Get the patient\'s personal health record by the others
   */
  async getPatientPersonalHealthRecordByTheOthersRaw(
    requestParameters: GetPatientPersonalHealthRecordByTheOthersRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PhrPersonalHealthRecord>> {
    if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
      throw new runtime.RequiredError(
        "patientId",
        "Required parameter requestParameters.patientId was null or undefined when calling getPatientPersonalHealthRecordByTheOthers."
      );
    }

    if (requestParameters.authToken === null || requestParameters.authToken === undefined) {
      throw new runtime.RequiredError(
        "authToken",
        "Required parameter requestParameters.authToken was null or undefined when calling getPatientPersonalHealthRecordByTheOthers."
      );
    }

    if (requestParameters.types === null || requestParameters.types === undefined) {
      throw new runtime.RequiredError(
        "types",
        "Required parameter requestParameters.types was null or undefined when calling getPatientPersonalHealthRecordByTheOthers."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.authToken !== undefined) {
      queryParameters["auth_token"] = requestParameters.authToken;
    }

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    if (requestParameters.types) {
      queryParameters["types"] = requestParameters.types;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patients/{patient_id}/personal-health-record`.replace(
          `{${"patient_id"}}`,
          encodeURIComponent(String(requestParameters.patientId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PhrPersonalHealthRecordFromJSON(jsonValue));
  }

  /**
   * Get the patient\'s personal health record by the others
   */
  async getPatientPersonalHealthRecordByTheOthers(
    requestParameters: GetPatientPersonalHealthRecordByTheOthersRequest,
    initOverrides?: RequestInit
  ): Promise<PhrPersonalHealthRecord> {
    return promiseRetry(
      (retry) =>
        this.getPatientPersonalHealthRecordByTheOthersRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Export the patient\'s own personal health record formatted JAHIS csv using JWT. Supported only medication
   */
  async getPatientPersonalHealthRecordCSVRaw(
    requestParameters: GetPatientPersonalHealthRecordCSVRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<Blob>> {
    const queryParameters: any = {};

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patient/personal-health-record.csv`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Export the patient\'s own personal health record formatted JAHIS csv using JWT. Supported only medication
   */
  async getPatientPersonalHealthRecordCSV(
    requestParameters: GetPatientPersonalHealthRecordCSVRequest,
    initOverrides?: RequestInit
  ): Promise<Blob> {
    return promiseRetry(
      (retry) =>
        this.getPatientPersonalHealthRecordCSVRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Get the latest export job status. Returns status and signed URL when generated.
   */
  async getPatientPersonalHealthRecordCsvRaw(
    requestParameters: GetPatientPersonalHealthRecordCsvRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<GetPersonalHealthRecordCsvResponse>> {
    const queryParameters: any = {};

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patient/personal-health-record/csv-exports`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => GetPersonalHealthRecordCsvResponseFromJSON(jsonValue));
  }

  /**
   * Get the latest export job status. Returns status and signed URL when generated.
   */
  async getPatientPersonalHealthRecordCsv(
    requestParameters: GetPatientPersonalHealthRecordCsvRequest,
    initOverrides?: RequestInit
  ): Promise<GetPersonalHealthRecordCsvResponse> {
    return promiseRetry(
      (retry) =>
        this.getPatientPersonalHealthRecordCsvRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Export the patient\'s own personal health record formatted XML using JWT
   */
  async getPatientPersonalHealthRecordZIPRaw(
    requestParameters: GetPatientPersonalHealthRecordZIPRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<Blob>> {
    if (requestParameters.types === null || requestParameters.types === undefined) {
      throw new runtime.RequiredError(
        "types",
        "Required parameter requestParameters.types was null or undefined when calling getPatientPersonalHealthRecordZIP."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    if (requestParameters.types) {
      queryParameters["types"] = requestParameters.types;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patient/personal-health-record.zip`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Export the patient\'s own personal health record formatted XML using JWT
   */
  async getPatientPersonalHealthRecordZIP(
    requestParameters: GetPatientPersonalHealthRecordZIPRequest,
    initOverrides?: RequestInit
  ): Promise<Blob> {
    return promiseRetry(
      (retry) =>
        this.getPatientPersonalHealthRecordZIPRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Get the latest export job status. Returns status, requested types and signed URL when generated.
   */
  async getPatientPersonalHealthRecordZipExportRaw(
    requestParameters: GetPatientPersonalHealthRecordZipExportRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<GetPersonalHealthRecordZipExportResponse>> {
    const queryParameters: any = {};

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patient/personal-health-record/zip-exports`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetPersonalHealthRecordZipExportResponseFromJSON(jsonValue)
    );
  }

  /**
   * Get the latest export job status. Returns status, requested types and signed URL when generated.
   */
  async getPatientPersonalHealthRecordZipExport(
    requestParameters: GetPatientPersonalHealthRecordZipExportRequest,
    initOverrides?: RequestInit
  ): Promise<GetPersonalHealthRecordZipExportResponse> {
    return promiseRetry(
      (retry) =>
        this.getPatientPersonalHealthRecordZipExportRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Get the patient\'s own personal health record share setting
   */
  async getPatientShareSettingRaw(
    requestParameters: GetPatientShareSettingRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PhrShareSetting>> {
    const queryParameters: any = {};

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patient/share-setting`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PhrShareSettingFromJSON(jsonValue));
  }

  /**
   * Get the patient\'s own personal health record share setting
   */
  async getPatientShareSetting(
    requestParameters: GetPatientShareSettingRequest,
    initOverrides?: RequestInit
  ): Promise<PhrShareSetting> {
    return promiseRetry(
      (retry) =>
        this.getPatientShareSettingRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * issue auth token to access the other personal health record
   */
  async postAuthTokenRaw(
    requestParameters: PostAuthTokenRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PhrAuthToken>> {
    if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
      throw new runtime.RequiredError(
        "patientId",
        "Required parameter requestParameters.patientId was null or undefined when calling postAuthToken."
      );
    }

    if (
      requestParameters.postAuthTokenRequestBody === null ||
      requestParameters.postAuthTokenRequestBody === undefined
    ) {
      throw new runtime.RequiredError(
        "postAuthTokenRequestBody",
        "Required parameter requestParameters.postAuthTokenRequestBody was null or undefined when calling postAuthToken."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patients/{patient_id}/auth-token`.replace(
          `{${"patient_id"}}`,
          encodeURIComponent(String(requestParameters.patientId))
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PostAuthTokenRequestBodyToJSON(requestParameters.postAuthTokenRequestBody),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PhrAuthTokenFromJSON(jsonValue));
  }

  /**
   * issue auth token to access the other personal health record
   */
  async postAuthToken(requestParameters: PostAuthTokenRequest, initOverrides?: RequestInit): Promise<PhrAuthToken> {
    return promiseRetry(
      (retry) =>
        this.postAuthTokenRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Register a job to export the patient\'s own personal health record as JAHIS CSV (medication only). Returns job id for polling.
   */
  async postPatientPersonalHealthRecordCsvGenerateRaw(
    requestParameters: PostPatientPersonalHealthRecordCsvGenerateRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PostPersonalHealthRecordCsvGenerateResponse>> {
    const queryParameters: any = {};

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patient/personal-health-record/csv-exports`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PostPersonalHealthRecordCsvGenerateResponseFromJSON(jsonValue)
    );
  }

  /**
   * Register a job to export the patient\'s own personal health record as JAHIS CSV (medication only). Returns job id for polling.
   */
  async postPatientPersonalHealthRecordCsvGenerate(
    requestParameters: PostPatientPersonalHealthRecordCsvGenerateRequest,
    initOverrides?: RequestInit
  ): Promise<PostPersonalHealthRecordCsvGenerateResponse> {
    return promiseRetry(
      (retry) =>
        this.postPatientPersonalHealthRecordCsvGenerateRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Import the patient\'s own personal health record from a XML file using JWT
   */
  async postPatientPersonalHealthRecordFileImportsRaw(
    requestParameters: PostPatientPersonalHealthRecordFileImportsRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PhrPersonalHealthRecord>> {
    if (requestParameters.type === null || requestParameters.type === undefined) {
      throw new runtime.RequiredError(
        "type",
        "Required parameter requestParameters.type was null or undefined when calling postPatientPersonalHealthRecordFileImports."
      );
    }

    if (
      requestParameters.postPersonalHealthRecordFileImportsRequestBody === null ||
      requestParameters.postPersonalHealthRecordFileImportsRequestBody === undefined
    ) {
      throw new runtime.RequiredError(
        "postPersonalHealthRecordFileImportsRequestBody",
        "Required parameter requestParameters.postPersonalHealthRecordFileImportsRequestBody was null or undefined when calling postPatientPersonalHealthRecordFileImports."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    if (requestParameters.type !== undefined) {
      queryParameters["type"] = requestParameters.type;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patient/personal-health-record/file-imports`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PostPersonalHealthRecordFileImportsRequestBodyToJSON(
          requestParameters.postPersonalHealthRecordFileImportsRequestBody
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PhrPersonalHealthRecordFromJSON(jsonValue));
  }

  /**
   * Import the patient\'s own personal health record from a XML file using JWT
   */
  async postPatientPersonalHealthRecordFileImports(
    requestParameters: PostPatientPersonalHealthRecordFileImportsRequest,
    initOverrides?: RequestInit
  ): Promise<PhrPersonalHealthRecord> {
    return promiseRetry(
      (retry) =>
        this.postPatientPersonalHealthRecordFileImportsRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Register a job to export the patient\'s own personal health record as XML zip. Returns job id for polling.
   */
  async postPatientPersonalHealthRecordZipExportGenerateRaw(
    requestParameters: PostPatientPersonalHealthRecordZipExportGenerateRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PostPersonalHealthRecordZipExportGenerateResponse>> {
    if (requestParameters.types === null || requestParameters.types === undefined) {
      throw new runtime.RequiredError(
        "types",
        "Required parameter requestParameters.types was null or undefined when calling postPatientPersonalHealthRecordZipExportGenerate."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    if (requestParameters.types) {
      queryParameters["types"] = requestParameters.types;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patient/personal-health-record/zip-exports`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PostPersonalHealthRecordZipExportGenerateResponseFromJSON(jsonValue)
    );
  }

  /**
   * Register a job to export the patient\'s own personal health record as XML zip. Returns job id for polling.
   */
  async postPatientPersonalHealthRecordZipExportGenerate(
    requestParameters: PostPatientPersonalHealthRecordZipExportGenerateRequest,
    initOverrides?: RequestInit
  ): Promise<PostPersonalHealthRecordZipExportGenerateResponse> {
    return promiseRetry(
      (retry) =>
        this.postPatientPersonalHealthRecordZipExportGenerateRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Upsert the patient\'s own personal health record share setting
   */
  async putPatientShareSettingRaw(
    requestParameters: PutPatientShareSettingRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PhrShareSetting>> {
    if (
      requestParameters.putShareSettingRequestBody === null ||
      requestParameters.putShareSettingRequestBody === undefined
    ) {
      throw new runtime.RequiredError(
        "putShareSettingRequestBody",
        "Required parameter requestParameters.putShareSettingRequestBody was null or undefined when calling putPatientShareSetting."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patient/share-setting`,
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: PutShareSettingRequestBodyToJSON(requestParameters.putShareSettingRequestBody),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PhrShareSettingFromJSON(jsonValue));
  }

  /**
   * Upsert the patient\'s own personal health record share setting
   */
  async putPatientShareSetting(
    requestParameters: PutPatientShareSettingRequest,
    initOverrides?: RequestInit
  ): Promise<PhrShareSetting> {
    return promiseRetry(
      (retry) =>
        this.putPatientShareSettingRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}

/**
 * @export
 * @enum {string}
 */
export enum DeletePatientPersonalHealthRecordTypesEnum {
  Medication = "medication",
  SpecificHealthCheckup = "specific_health_checkup",
  MedicalExpenseNotification = "medical_expense_notification",
}
/**
 * @export
 * @enum {string}
 */
export enum GetPatientPersonalHealthRecordTypesEnum {
  Medication = "medication",
  SpecificHealthCheckup = "specific_health_checkup",
  MedicalExpenseNotification = "medical_expense_notification",
}
/**
 * @export
 * @enum {string}
 */
export enum GetPatientPersonalHealthRecordByTheOthersTypesEnum {
  Medication = "medication",
  SpecificHealthCheckup = "specific_health_checkup",
  MedicalExpenseNotification = "medical_expense_notification",
}
/**
 * @export
 * @enum {string}
 */
export enum GetPatientPersonalHealthRecordZIPTypesEnum {
  Medication = "medication",
  SpecificHealthCheckup = "specific_health_checkup",
  MedicalExpenseNotification = "medical_expense_notification",
}
/**
 * @export
 * @enum {string}
 */
export enum PostPatientPersonalHealthRecordFileImportsTypeEnum {
  Medication = "medication",
  SpecificHealthCheckup = "specific_health_checkup",
  MedicalExpenseNotification = "medical_expense_notification",
}
/**
 * @export
 * @enum {string}
 */
export enum PostPatientPersonalHealthRecordZipExportGenerateTypesEnum {
  Medication = "medication",
  SpecificHealthCheckup = "specific_health_checkup",
  MedicalExpenseNotification = "medical_expense_notification",
}
